import {
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  InputAdornment,
  Button,
  CircularProgress,
  Select,
  ListItemText,
  MenuItem,
  InputLabel,
  FormControl,
  Box,
  Tab,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  tableCellClasses,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormControlLabel,
  Chip,
  Alert,
  Switch,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { Formik, ErrorMessage, FormikProps, Form } from "formik";
import React, { useEffect, useState } from "react";
import LinkIcon from "@mui/icons-material/Link";
import KeyIcon from "@mui/icons-material/Key";
import { styled, useTheme } from "@mui/material/styles";
import PageLoader from "../../compenents/app/PageLoader";
import {
  SetupProfile,
  SetupProfileInitialValues,
  SetupProfileValidationSchema,
} from "../../models/features/SetupProfile/SetupProfile";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import {
  useGetDealerLocationsMutation,
  useGetDmsSetupByIdMutation,
  useUpdateSetupProfileMutation,
  useUpdateSetupLocationMutation,
  useAddSetupLocationMutation,
  useGetShopifyLocationsMutation,
  useVerifyAccessTokenMutation,
  useGetDMSManufacturersBySetupIdQuery,
  useAddDmsManufacturerMutation,
  useDeleteDmsManufacturerMutation,
  useUpdateActualSetupLocationMutation,
  useSetDMSLocationDefaultMutation,
  useRemoveDealerSetupMutation,
} from "../../redux/reducer/features/Integration/DmsSetupSlice";
import {
  addDmsLocation,
  setSetupId,
  RefreshTokenApi,
} from "../../redux/reducer/features/Auth/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../redux/reducer/rootReducer";
import { DealerLocation } from "../../models/features/Integration/DmsSetup";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { setSyncExisting } from "../../redux/reducer/features/Auth/authSlice";
import InfoIcon from "@mui/icons-material/Info";
import { DmsManufacturer } from "../../models/features/ShoppingPortal/DmsManufacturer";
import { useGetDmsManufacturersQuery } from "../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { useGetManufacturersQuery } from "../../redux/reducer/features/Product/productSlice";
import { ProductManufacturer } from "../../models/features/Product/Product";
import DeleteIcon from "@mui/icons-material/Delete";
import LocationSearchingIcon from "@mui/icons-material/LocationSearching";
import EditLocationDialog from "./EditLocationDialog";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Dispatch } from "@reduxjs/toolkit";
import { GravitySetting } from "../Setting/Payment/PaymentSetting";
import PortalSettingRules from "../Setting/Portal Setting Rules/PortalSettingRules";
import { PartsPortalType } from "../../models/features/ShopifySetting/ShoppingPortal/ShoppingPortal";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.common.black,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

export const SetupProfilePage: React.FunctionComponent = () => {
  const dispatch = useDispatch<Dispatch<any>>();
  const everestDmsDealerId = useSelector(
    (state: AppState) => state.authReducer.everestDmsDealerId
  );
  const setupId = useSelector((state: AppState) => state.authReducer.setupId);
  const refreshToken = useSelector(
    (state: AppState) => state.authReducer.refreshToken
  );
  const locations = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.dmsLocations
  );
  const dealerName = useSelector((state: AppState) => state.authReducer.name);
  const [setupProfileData, setSetupProfileData] = useState<SetupProfile>(
    SetupProfileInitialValues
  );
  const [mfrFilter, setMfrFilter] = React.useState("all");
  const [mfrPopupFilter, setMfrPopupFilter] = React.useState("all");
  const [selectedLocations, setSelectedLocations] = React.useState<
    DealerLocation[]
  >([]);
  const [shopifyLocations, setshopifyLocations] = React.useState<any[]>([]);
  const [
    verifyShopifyCredentialsMutation,
    verifyShopifyCredentialsMutationResult,
  ] = useVerifyAccessTokenMutation();

  const [dmsLocations, setDmsLocations] = React.useState<DealerLocation[]>([]);
  const [nonAddedLocations, setNonAddedLocations] = React.useState<
    DealerLocation[]
  >([]);
  const [newAddedLocation, setNewAddedLocation] =
    React.useState<DealerLocation>();
  const [selectedShopifyLocation, setSelectedShopifyLocation] =
    React.useState<any>({});
  const { data: catalogMfrs } = useGetManufacturersQuery();
  const { data, refetch, isSuccess } = useGetDMSManufacturersBySetupIdQuery({
    setupId: setupId ?? "",
  });
  const { data: dmsManufacturersList } = useGetDmsManufacturersQuery({
    dealerId: locations ? locations[0].dealerId.toString() ?? "" : "",
  });

  const [dmsLocationMutation, dmsLocationMutationResult] =
    useGetDealerLocationsMutation();
  const [deleteDmsMfrMutation, deleteDmsMfrMutationResult] =
    useDeleteDmsManufacturerMutation();
  const [addSetupLocationMutation, addSetupLocationMutationResult] =
    useAddSetupLocationMutation();
  const [addDmsManufacturerMutation, addDmsManufacturerMutationResult] =
    useAddDmsManufacturerMutation();
  const [updateLocationMutation, updateLocationMutationResult] =
    useUpdateSetupLocationMutation();
  const [updateActualLocationMutation, updateActualLocationMutationResult] =
    useUpdateActualSetupLocationMutation();
  const [dmsSetupMutation, dmsSetupMutationResult] =
    useGetDmsSetupByIdMutation();
  const [updateDmsSetupMutation, updateDmsSetupMutationResult] =
    useUpdateSetupProfileMutation();
  const [shopifyLocationMutation, shopifyLocationMutationResult] =
    useGetShopifyLocationsMutation();
  const [setLocationDefaultMutation, setLocationDefaultMutationResult] =
    useSetDMSLocationDefaultMutation();
  const [removeSetupMutation, removeSetupMutationResult] =
    useRemoveDealerSetupMutation();
  const formRef: React.Ref<FormikProps<SetupProfile>> = React.useRef(null);
  const [selectedRowId, setSelectedRowId] = React.useState<any>(null);
  const [editLocation, setEditLocation] = React.useState<DealerLocation>();
  const [openActualEditLocation, setOpenActualEditLocation] =
    React.useState(false);
  const [removeMappingConfirm, setRemoveMappingConfirm] = React.useState(false);
  const [openLocation, setOpenLocation] = React.useState(false);
  const [openEditLocation, setOpenEditLocation] = React.useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [value, setValue] = React.useState("profile");
  const [isVerified, setIsVerified] = React.useState(false);
  const [showVerification, setShowVerification] = React.useState(false);
  const [verificationMessage, setVerificationMessage] = useState("");
  const [openMfrMapping, setOpenMfrMapping] = useState(false);
  const [isEditMfrMapping, setIsEditMfrMapping] = useState(false);
  const [syncSettingConfirm, setSyncSettingConfirm] = useState(false);
  const [dmsManufacturersBySetup, setDmsManufacturersBySetup] = useState<
    DmsManufacturer[]
  >([]);
  const [manufacturersByCatalog, setManufacturersByCatalog] = useState<
    ProductManufacturer[]
  >([]);
  const [dmsManufacturersByEverest, setDmsManufacturersByEverest] = useState<
    DmsManufacturer[]
  >([]);
  const [selectedCatalogMfr, setselectedCatalogMfr] = React.useState<
    ProductManufacturer | undefined
  >(undefined);
  const [selectedDmsMfr, setSelectedDmsMfr] = React.useState<DmsManufacturer>();
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [deleteFinalConfirm, setDeleteFinalConfirm] = React.useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleClose = () => {
    setErrorMessage("");
    setRemoveMappingConfirm(false);
    setOpenLocation(false);
    setOpenActualEditLocation(false);
    setOpenEditLocation(false);
    setOpenMfrMapping(false);
    setSelectedShopifyLocation(undefined);
    setselectedCatalogMfr(undefined);
    setSelectedDmsMfr(undefined);
    setIsEditMfrMapping(false);
    setSyncSettingConfirm(false);
    setDeleteConfirm(false);
    setDeleteFinalConfirm(false);
  };
  const handleOpenAddLocation = () => {
    setNewAddedLocation(undefined);
    setNonAddedLocations(
      dmsLocations.filter(
        (loc) =>
          !selectedLocations.some((x) => x.dmsLocationId === loc.dmsLocationId)
      )
    );
    setOpenLocation(true);
  };

  const handleOpenAddManufacturer = () => {
    setSelectedDmsMfr(undefined);
    setOpenMfrMapping(true);
  };

  const handleOpenFinalConfirm = () => {
    setDeleteConfirm(false);
    setDeleteFinalConfirm(true);
  };

  const onDeleteSetup = () => {
    setDeleteConfirm(false);
    setDeleteFinalConfirm(false);
    removeSetupMutation({ setupId: setupId ?? "" })
      .then((res: any) => {
        if (res.data && res.data.status === 0) {
          dispatch(
            RefreshTokenApi(refreshToken ?? "", () => {
              dispatch(setSetupId(""));
            })
          );
        }
      })
      .catch((err) => {});
  };

  const handleUpdateMapping = (shopifyLocationId: number) => {
    updateLocationMutation({
      id: selectedRowId,
      shopifyLocationId: shopifyLocationId,
    }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 200) {
          setRemoveMappingConfirm(false);
          setOpenEditLocation(false);
          setSelectedLocations(
            selectedLocations.map((loc) =>
              loc.id === selectedRowId
                ? { ...loc, shopifyLocationId: shopifyLocationId }
                : loc
            )
          );
        }
      }
    });
  };

  const handleSaveLocation = () => {
    if (newAddedLocation !== undefined) {
      addSetupLocationMutation({
        location: {
          ...newAddedLocation,
          shopifyLocationId: selectedShopifyLocation.id ?? 0,
        },
      }).then((res: any) => {
        if (res && res.data) {
          if (res.data.status === 200) {
            dispatch(addDmsLocation(res.data.entity));
            setSelectedLocations([
              ...selectedLocations,
              {
                ...newAddedLocation,
                shopifyLocationId: selectedShopifyLocation.id,
                id: res.data.entity.id,
              },
            ]);
            handleClose();
          } else {
            setErrorMessage(res?.data?.message);
          }
        }
      });
    }
  };

  const handleUpdateLocation = (location: DealerLocation) => {
    if (location !== undefined) {
      updateActualLocationMutation({
        location: location,
      }).then((res: any) => {
        if (res && res.data) {
          if (res.data.status === 200) {
            dispatch(addDmsLocation(res.data.entity));
            setSelectedLocations(
              selectedLocations.map((x) =>
                x.dealerId === res.data.entity.dealerId ? res.data.entity : x
              )
            );
            handleClose();
          } else {
            setErrorMessage(res?.data?.message);
          }
        }
      });
    }
  };
  const handleChangeDMSLocation = (value: any) => {
    var newLoc = dmsLocations.find((c) => c.dmsLocationId === value);
    setNewAddedLocation(newLoc);
  };
  const handleChangeDMSManufacturer = (value: any) => {
    var newMfr = dmsManufacturersByEverest.find(
      (c) => c.manufacturerId === value
    );
    setSelectedDmsMfr(newMfr);
  };
  const handleChangeCatalogMfr = (value: string) => {
    var newMfr = manufacturersByCatalog.find((c) => c?.id === value);
    setselectedCatalogMfr(newMfr);
  };
  const handleChangeShopifyLocation = (value: number) => {
    var newLoc = shopifyLocations.find((c) => c?.id === value);
    setSelectedShopifyLocation(newLoc);
  };
  const handleCloseAlert = () => {
    setShowVerification(false);
  };
  const handleOnSubmit = (values: SetupProfile) => {
    setShowVerification(false);
    setVerificationMessage("");
    dispatch(setSyncExisting(values.syncExisting));
    verifyShopifyCredentialsMutation({
      shopUrl: values.shopifyUrl ?? "",
      shopAccessToken: values.shopifyAccessToken ?? "",
    }).then((res: any) => {
      if (res && res.data) {
        if (res.data.status === 0) {
          SaveProfileSetting(values);
        } else {
          setIsVerified(false);
          setVerificationMessage(
            "Your Shopify credentials (Shopify Url OR Access token) are not Valid."
          );
          setShowVerification(true);
        }
      }
    });
  };

  const SaveProfileSetting = (values: SetupProfile) => {
    updateDmsSetupMutation({ data: values }).then((res: any) => {
      if (res && res.data) {
        setIsVerified(true);
        setVerificationMessage("Profile Setting saved successfully.");
        setShowVerification(true);
        let data = res?.data.entity;
        setSetupProfileData({
          id: data.id,
          shopifyUrl: data.shopifyUrl,
          shopifyAccessToken: data.shopifyAccessToken,
          syncExisting: data.syncExisting,
          IsUpdateCustomerAndPaymentOnly: false,
        });
      }
    });
  };

  const theme = useTheme();

  React.useEffect(() => {
    if (!setupId || setupId === "") {
      setTimeout(() => {
        window.location.href = "/";
      }, 1500);
    }
  }, [setupId]);

  useEffect(() => {
    dmsLocationMutation({
      everestDmsDealerId: everestDmsDealerId ?? "",
    }).then((response: any) => {
      if (response) {
        setDmsLocations(response?.data?.entityList);
      }
    });
  }, []);
  useEffect(() => {
    dmsSetupMutation({}).then((response: any) => {
      if (response && response.data && response.data.status === 0) {
        let data = response?.data.entity;
        handleGetShopifyLocations(data.shopifyUrl, data.shopifyAccessToken);
        let selectedLocs: DealerLocation[] = data.dmsLocations.map(
          (loc: any) => ({
            id: loc.id,
            dealerId: loc.dealerId,
            dmsType: 0,
            dmsLocationId: loc.dmsLocationId,
            name: loc.name,
            address: loc.address,
            city: loc.city,
            stateOrProvince: loc.stateOrProvince,
            zipPostal: loc.zipPostal,
            shopifyLocationId: loc.shopifyLocationId,
            email: loc.email,
            phone: loc.phone,
            isDefault: loc.isDefault,
          })
        );
        setSelectedLocations(selectedLocs);
        setSetupProfileData({
          id: data.id,
          shopifyUrl: data.shopifyUrl,
          shopifyAccessToken: data.shopifyAccessToken,
          syncExisting: data.syncExisting,
          IsUpdateCustomerAndPaymentOnly: false,
        });
      }
    });
  }, []);

  useEffect(() => {
    if (data && data.status === 200) {
      setDmsManufacturersBySetup(data.entityList ?? []);
    }
  }, [data]);

  useEffect(() => {
    if (catalogMfrs && catalogMfrs.status === 0) {
      setManufacturersByCatalog(catalogMfrs.entityList ?? []);
    }
  }, [catalogMfrs]);

  React.useEffect(() => {
    if (
      dmsManufacturersList?.entityList &&
      dmsManufacturersList.entityList?.length > 0
    ) {
      setDmsManufacturersByEverest(dmsManufacturersList.entityList);
    }
  }, [dmsManufacturersList]);

  const handleGetShopifyLocations = (url: string, token: string) => {
    shopifyLocationMutation({
      shopAccessToken: token,
      shopUrl: url,
    }).then((res: any) => {
      if (res && res.data) {
        setshopifyLocations(res?.data?.entityList);
      }
    });
  };

  const handleSetDefault = (id: any, value: boolean) => {
    setSelectedLocations(
      selectedLocations.map((item) =>
        item.id === id
          ? { ...item, isDefault: value }
          : { ...item, isDefault: false }
      )
    );
    setLocationDefaultMutation({ locationId: id, isDefault: value });
  };

  const isMapped = (shopifyLocationId: number) => {
    return selectedLocations.some(
      (loc) => loc.shopifyLocationId === shopifyLocationId
    );
  };
  const getShopifyLocationName = (shopifyLocationId: number) => {
    return (
      shopifyLocations.find((loc) => loc.id === shopifyLocationId)?.name ?? ""
    );
  };

  const handleAddManufacturer = () => {
    addDmsManufacturerMutation({
      request: {
        ...selectedDmsMfr,
        id: isEditMfrMapping ? selectedDmsMfr?.id : undefined,
        catalogManufacturerId: selectedCatalogMfr?.id ?? "",
      },
    }).then((res: any) => {
      if (res && res.data) {
        if (res && res.data.status === 200) {
          handleClose();
          refetch();
        }
      }
    });
  };

  const handleDeleteDmsManufacturer = () => {
    deleteDmsMfrMutation({ mfrId: selectedDmsMfr?.id ?? "" }).then(
      (res: any) => {
        if (res && res.data) {
          let mfrs = dmsManufacturersBySetup.filter(
            (x) => x.id !== selectedDmsMfr?.id
          );
          setDmsManufacturersBySetup(mfrs);
          setRemoveMappingConfirm(false);
        }
      }
    );
    setSelectedDmsMfr(undefined);
  };

  return (
    <>
      <PageLoader
        isLoading={
          dmsSetupMutationResult.isLoading ||
          removeSetupMutationResult.isLoading
        }
      ></PageLoader>

      <Container maxWidth={false}>
        <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
          Setup Profile
        </Typography>
        <Card sx={{ minHeight: "50vh" }}>
          <CardContent>
            <Grid container>
              <TabContext value={value.toString()}>
                <Grid
                  item
                  xs={2}
                  sx={{
                    bgcolor: theme.palette.action.hover,
                    minHeight: "50vh",
                  }}
                >
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                    orientation="vertical"
                    sx={{ mt: 1 }}
                  >
                    <Tab
                      sx={{
                        backgroundColor:
                          value === "profile" ? "white" : "inherit",
                      }}
                      label="Profile"
                      value="profile"
                    />
                    <Tab
                      sx={{
                        backgroundColor:
                          value === "locations" ? "white" : "inherit",
                      }}
                      label="Locations"
                      value="locations"
                    />
                    <Tab
                      sx={{
                        backgroundColor:
                          value === "manufacturers" ? "white" : "inherit",
                      }}
                      label="Manufacturers"
                      value="manufacturers"
                    />
                    <Tab
                      sx={{
                        backgroundColor:
                          value === "orderPaymentSettings"
                            ? "white"
                            : "inherit",
                      }}
                      label="Order / Payment Settings"
                      value="orderPaymentSettings"
                    />
                    <Tab
                      sx={{
                        backgroundColor:
                          value === "portalSettingRules" ? "white" : "inherit",
                      }}
                      label="Portal Setting Rules"
                      value="portalSettingRules"
                    />
                  </TabList>
                </Grid>
                <Grid item xs={10}>
                  <TabPanel value="profile">
                    <Formik
                      initialValues={setupProfileData}
                      enableReinitialize={true}
                      validationSchema={SetupProfileValidationSchema}
                      innerRef={formRef}
                      onSubmit={(values) => {
                        handleOnSubmit(values);
                      }}
                    >
                      {({
                        values,
                        handleChange,
                        handleBlur,
                        setFieldValue,
                      }) => (
                        <>
                          <Form>
                            <Grid container spacing={3} p={2}>
                              <Grid item xs={12}>
                                <TextField
                                  id="profileName"
                                  name="profileName"
                                  label="Name"
                                  fullWidth
                                  variant="standard"
                                  value={dealerName}
                                  disabled
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField
                                  id="shopifyUrl"
                                  name="shopifyUrl"
                                  label="Shopify Url"
                                  fullWidth
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.shopifyUrl}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <LinkIcon
                                          sx={{ color: "rgb(56, 55, 110)" }}
                                        />
                                      </InputAdornment>
                                    ),
                                  }}
                                  variant="standard"
                                />
                                <ErrorMessage
                                  className="error-msg"
                                  component={"div"}
                                  name="shopifyUrl"
                                />
                              </Grid>
                              <Grid item xs={6}>
                                <TextField
                                  disabled
                                  id="shopifyAccessToken"
                                  name="shopifyAccessToken"
                                  label="Shopify Access Token"
                                  fullWidth
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={
                                    values.shopifyAccessToken ??
                                    "*************************************************************"
                                  }
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="end">
                                        <KeyIcon
                                          sx={{ color: "rgb(56, 55, 110)" }}
                                        />
                                      </InputAdornment>
                                    ),
                                  }}
                                  variant="standard"
                                />
                                <ErrorMessage
                                  className="error-msg"
                                  component={"div"}
                                  name="shopifyAccessToken"
                                />
                              </Grid>
                              <Grid item xs={12}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={values.syncExisting}
                                      color="secondary"
                                      name="syncExisting"
                                      onChange={(e) => {
                                        e.preventDefault();
                                        setSyncSettingConfirm(true);
                                      }}
                                    />
                                  }
                                  label="I want to Sync only Existing Shopify Products"
                                />
                              </Grid>
                              <Dialog
                                open={syncSettingConfirm}
                                fullWidth
                                onClose={handleClose}
                              >
                                <DialogTitle>
                                  Confirm to Change Syncing setting
                                </DialogTitle>
                                <DialogContent sx={{ fontSize: "14px" }}>
                                  By changing this setting, System will start
                                  sync products{" "}
                                  {!values.syncExisting
                                    ? "from Shopify to Target Web (Reverse Sync)."
                                    : "from  Target Web to Shopify (Regular Sync)."}
                                  <br /> Are you sure to perform this action?
                                </DialogContent>
                                <DialogActions>
                                  <Button
                                    variant="outlined"
                                    autoFocus
                                    onClick={() => {
                                      setSyncSettingConfirm(false);
                                    }}
                                  >
                                    No
                                  </Button>
                                  <Button
                                    variant="contained"
                                    onClick={() => {
                                      setFieldValue(
                                        "syncExisting",
                                        !values.syncExisting
                                      );
                                      setSyncSettingConfirm(false);
                                    }}
                                  >
                                    YES
                                  </Button>
                                </DialogActions>
                              </Dialog>
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                <Box>
                                  {showVerification ? (
                                    <Alert
                                      onClose={handleCloseAlert}
                                      severity={
                                        isVerified ? "success" : "error"
                                      }
                                    >
                                      {verificationMessage}
                                    </Alert>
                                  ) : (
                                    ""
                                  )}
                                </Box>
                                <Button
                                  variant="contained"
                                  type="submit"
                                  endIcon={
                                    updateDmsSetupMutationResult.isLoading ||
                                    verifyShopifyCredentialsMutationResult.isLoading ? (
                                      <CircularProgress
                                        color="inherit"
                                        size={20}
                                      />
                                    ) : (
                                      <></>
                                    )
                                  }
                                  disabled={
                                    updateDmsSetupMutationResult.isLoading ||
                                    verifyShopifyCredentialsMutationResult.isLoading
                                  }
                                >
                                  Save
                                </Button>
                              </Grid>
                            </Grid>
                          </Form>
                        </>
                      )}
                    </Formik>
                    <Chip
                      sx={{ fontWeight: "normal", ml: 1 }}
                      label="Remove Setup"
                      size="small"
                      color="error"
                      icon={<DeleteForeverIcon />}
                      onClick={() => {
                        setDeleteConfirm(true);
                      }}
                    ></Chip>
                  </TabPanel>
                  <TabPanel
                    value="locations"
                    sx={{ padding: 0, paddingLeft: 3 }}
                  >
                    <Box display="flex" justifyContent="right" mb={1}>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={handleOpenAddLocation}
                        startIcon={<AddIcon />}
                      >
                        Add Location
                      </Button>
                    </Box>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 700 }}
                        aria-label="customized table"
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell sx={{ fontWeight: "bold" }}>
                              Dealer Id
                            </StyledTableCell>
                            <StyledTableCell sx={{ fontWeight: "bold" }}>
                              Location Name
                            </StyledTableCell>
                            <StyledTableCell sx={{ fontWeight: "bold" }}>
                              Shopify Name
                            </StyledTableCell>
                            <StyledTableCell sx={{ fontWeight: "bold" }}>
                              Address
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              sx={{ fontWeight: "bold" }}
                            >
                              Zip Code
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              sx={{ fontWeight: "bold" }}
                            >
                              Default
                            </StyledTableCell>
                            <StyledTableCell
                              align="center"
                              sx={{ fontWeight: "bold" }}
                            >
                              Status
                            </StyledTableCell>
                            <StyledTableCell
                              sx={{ fontWeight: "bold" }}
                              align="center"
                            >
                              Actions
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {selectedLocations.length > 0 ? (
                            selectedLocations.map((row) => (
                              <TableRow key={row.dmsLocationId}>
                                <StyledTableCell sx={{ padding: 1.5 }}>
                                  {row.dealerId}
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: 1.5 }}>
                                  {row.name}
                                </StyledTableCell>
                                <StyledTableCell sx={{ padding: 1.5 }}>
                                  {getShopifyLocationName(
                                    row.shopifyLocationId
                                  )}
                                </StyledTableCell>
                                <StyledTableCell
                                  sx={{
                                    padding: 1.5,
                                    maxWidth: 200,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                  align="left"
                                >
                                  {row.address}
                                </StyledTableCell>
                                <StyledTableCell
                                  sx={{ padding: 1.5 }}
                                  align="center"
                                >
                                  {row.zipPostal}
                                </StyledTableCell>
                                <StyledTableCell align="center">
                                  {" "}
                                  <Switch
                                    checked={row?.isDefault ?? false}
                                    name="isDefault"
                                    size="small"
                                    onChange={(e) => {
                                      handleSetDefault(
                                        row.id,
                                        e.target.checked
                                      );
                                    }}
                                    inputProps={{ "aria-label": "controlled" }}
                                  />
                                </StyledTableCell>
                                <StyledTableCell
                                  sx={{ padding: 1.5 }}
                                  align="center"
                                >
                                  {row.shopifyLocationId > 0 ? (
                                    <Chip
                                      size="small"
                                      color="success"
                                      label="Mapped"
                                    ></Chip>
                                  ) : (
                                    <Chip
                                      size="small"
                                      color="error"
                                      label="Not Mapped"
                                    ></Chip>
                                  )}
                                </StyledTableCell>
                                <StyledTableCell
                                  sx={{ padding: 0.5 }}
                                  align="center"
                                >
                                  <IconButton
                                    id="basic-button"
                                    onClick={(n) => {
                                      setSelectedRowId(row.id);
                                      setOpenEditLocation(true);
                                    }}
                                  >
                                    <LocationSearchingIcon fontSize="small" />
                                  </IconButton>{" "}
                                  |{" "}
                                  <IconButton
                                    id="basic-button"
                                    onClick={(n) => {
                                      console.log("row:", row);
                                      setEditLocation(row);
                                      setOpenActualEditLocation(true);
                                    }}
                                  >
                                    <EditIcon fontSize="small" />
                                  </IconButton>{" "}
                                  |{" "}
                                  <IconButton
                                    disabled={row.shopifyLocationId === 0}
                                    id="basic-button"
                                    onClick={(n) => {
                                      setSelectedRowId(row.id);
                                      setRemoveMappingConfirm(true);
                                    }}
                                  >
                                    <CloseIcon fontSize="small" />
                                  </IconButton>
                                </StyledTableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableRow>
                              <StyledTableCell align="center" colSpan={7}>
                                No Rows to Show
                              </StyledTableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                  <TabPanel
                    value="manufacturers"
                    sx={{ padding: 0, paddingLeft: 3 }}
                  >
                    <Box display="flex" justifyContent="right" mb={1}>
                      <Button
                        size="small"
                        variant="contained"
                        onClick={handleOpenAddManufacturer}
                        startIcon={<AddIcon />}
                        style={{ marginRight: 10 }}
                      >
                        Add Manufacturer
                      </Button>
                      <Select
                        value={mfrFilter}
                        sx={{ width: "110px" }}
                        onChange={(e) => setMfrFilter(e.target.value)}
                        variant="standard"
                      >
                        <MenuItem selected value="all">
                          All
                        </MenuItem>
                        <MenuItem value="part">Part</MenuItem>
                        <MenuItem value="wholegood">Wholegood</MenuItem>
                      </Select>
                    </Box>
                    <TableContainer
                      sx={{ maxHeight: "45vh" }}
                      component={Paper}
                    >
                      <Table
                        sx={{ minWidth: 700 }}
                        aria-label="customized table"
                      >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell sx={{ fontWeight: "bold" }}>
                              DMS Mfr Code
                            </StyledTableCell>
                            <StyledTableCell sx={{ fontWeight: "bold" }}>
                              DMS Mfr Name
                            </StyledTableCell>
                            <StyledTableCell sx={{ fontWeight: "bold" }}>
                              Type
                            </StyledTableCell>
                            <StyledTableCell sx={{ fontWeight: "bold" }}>
                              Catalog Mfr Name
                            </StyledTableCell>

                            <StyledTableCell
                              align="center"
                              sx={{ fontWeight: "bold" }}
                            >
                              Status
                            </StyledTableCell>
                            <StyledTableCell
                              sx={{ fontWeight: "bold" }}
                              align="center"
                            >
                              Actions
                            </StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {dmsManufacturersBySetup.length > 0 ? (
                            dmsManufacturersBySetup
                              .filter((n) => {
                                if (mfrFilter === "all") return true;
                                if (
                                  mfrFilter === "wholegood" &&
                                  n.isWholegoodManufacturer
                                )
                                  return true;
                                if (
                                  mfrFilter === "part" &&
                                  n.isPartManufacturer
                                )
                                  return true;
                                return false;
                              })
                              .map((row, index) => (
                                <TableRow key={index}>
                                  <StyledTableCell sx={{ padding: 1.5 }}>
                                    {row.code}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ padding: 1.5 }}>
                                    {row.name}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ padding: 1.5 }}>
                                    {row.isPartManufacturer && (
                                      <Chip label="Part" size="small" />
                                    )}
                                    {row.isWholegoodManufacturer && (
                                      <Chip label="Wholegood" size="small" />
                                    )}
                                  </StyledTableCell>
                                  <StyledTableCell sx={{ padding: 1.5 }}>
                                    {row?.catalogManufacturer?.title}
                                  </StyledTableCell>
                                  <StyledTableCell
                                    sx={{ padding: 1.5 }}
                                    align="center"
                                  >
                                    {row.catalogManufacturerId ? (
                                      <Chip
                                        size="small"
                                        color="success"
                                        label="Mapped"
                                      ></Chip>
                                    ) : (
                                      <Chip
                                        size="small"
                                        color="error"
                                        label="Not Mapped"
                                      ></Chip>
                                    )}
                                  </StyledTableCell>
                                  <StyledTableCell
                                    sx={{ padding: 0.5 }}
                                    align="center"
                                  >
                                    <IconButton
                                      id="basic-button"
                                      onClick={(n) => {
                                        setSelectedDmsMfr(row);
                                        setIsEditMfrMapping(true);
                                        setOpenMfrMapping(true);
                                      }}
                                    >
                                      <EditIcon fontSize="small" />
                                    </IconButton>{" "}
                                    |{" "}
                                    <IconButton
                                      id="basic-button"
                                      onClick={(n) => {
                                        setSelectedDmsMfr(row);
                                        setRemoveMappingConfirm(true);
                                      }}
                                    >
                                      <DeleteIcon fontSize="small" />
                                    </IconButton>
                                  </StyledTableCell>
                                </TableRow>
                              ))
                          ) : (
                            <TableRow>
                              <StyledTableCell align="center" colSpan={7}>
                                No Rows to Show
                              </StyledTableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </TabPanel>
                  <TabPanel value="orderPaymentSettings">
                    <GravitySetting />
                  </TabPanel>
                  <TabPanel value="portalSettingRules">
                    <PortalSettingRules />
                  </TabPanel>
                </Grid>
              </TabContext>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog open={removeMappingConfirm} onClose={handleClose} fullWidth>
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          {value === "locations"
            ? "Confirm to Remove Mapping"
            : "Confirm to Delete"}
        </DialogTitle>
        <DialogContent>
          {value === "locations"
            ? "Are you sure to remove shopify location mapping with this DMS Location?"
            : "Are you sure to delete this manufacturer mapping?"}
        </DialogContent>
        <DialogActions>
          <Button
            autoFocus
            onClick={() => {
              setRemoveMappingConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            disabled={
              updateLocationMutationResult.isLoading ||
              deleteDmsMfrMutationResult.isLoading
            }
            endIcon={
              updateLocationMutationResult.isLoading ||
              deleteDmsMfrMutationResult.isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <></>
              )
            }
            onClick={() => {
              value === "locations"
                ? handleUpdateMapping(0)
                : handleDeleteDmsManufacturer();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openLocation} onClose={handleClose} fullWidth>
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          Add Location
        </DialogTitle>
        <DialogContent sx={{ minHeight: "15vh" }}>
          <Typography fontSize="15px">
            Select a DMS location and a Shopify location to map them.
          </Typography>
          <Box>
            <FormControl variant="outlined" fullWidth sx={{ mt: 3 }}>
              <InputLabel id="location">DMS Location</InputLabel>
              <Select
                labelId="location"
                id="locationId"
                size="small"
                label="DMS Location"
                fullWidth
                value={newAddedLocation?.dmsLocationId ?? 0}
                onChange={(e) => handleChangeDMSLocation(e.target.value)}
              >
                {nonAddedLocations.map((col) => (
                  <MenuItem key={col.dmsLocationId} value={col.dmsLocationId}>
                    <ListItemText primary={col.name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
          <FormControl variant="outlined" fullWidth sx={{ mt: 3 }}>
            <InputLabel id="shopify-location">Shopify location</InputLabel>
            <Select
              labelId="shopify-location"
              id="shopifylocationId"
              size="small"
              label="Shopify Location"
              fullWidth
              value={selectedShopifyLocation?.id ?? 0}
              onChange={(e) => handleChangeShopifyLocation(e.target.value)}
            >
              {shopifyLocations.map((col) => (
                <MenuItem
                  disabled={isMapped(col.id)}
                  key={col.id}
                  value={col.id}
                >
                  <ListItemText primary={col.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography mt={3} color="error">
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={
              nonAddedLocations.length === 0 ||
              !newAddedLocation ||
              addSetupLocationMutationResult.isLoading ||
              !selectedShopifyLocation
            }
            endIcon={
              addSetupLocationMutationResult.isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <></>
              )
            }
            onClick={() => {
              if (newAddedLocation) handleSaveLocation();
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <EditLocationDialog
        handleClose={handleClose}
        handleUpdateLocation={handleUpdateLocation}
        editLocation={editLocation}
        openActualEditLocation={openActualEditLocation}
        isLoading={updateActualLocationMutationResult.isLoading}
      ></EditLocationDialog>

      <Dialog open={openEditLocation} onClose={handleClose} fullWidth>
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          Edit Mapping
        </DialogTitle>
        <DialogContent sx={{ minHeight: "15vh" }}>
          <Typography fontSize="15px">
            Select a Shopify location to complete mapping.
          </Typography>
          <FormControl fullWidth sx={{ mt: 3 }}>
            <InputLabel id="shopify-location">Shopify location</InputLabel>
            <Select
              labelId="shopify-location"
              id="shopifylocationId"
              size="small"
              label="Shopify Location"
              fullWidth
              value={selectedShopifyLocation?.id ?? 0}
              onChange={(e) => handleChangeShopifyLocation(e.target.value)}
            >
              {shopifyLocations.map((col) => (
                <MenuItem
                  disabled={isMapped(col.id)}
                  key={col.id}
                  value={col.id}
                >
                  <ListItemText primary={col.name} />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography mt={3} color="error">
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={
              updateLocationMutationResult.isLoading || !selectedShopifyLocation
            }
            endIcon={
              updateLocationMutationResult.isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <></>
              )
            }
            onClick={() => {
              if (selectedRowId && selectedShopifyLocation)
                handleUpdateMapping(selectedShopifyLocation.id);
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={openMfrMapping} onClose={handleClose} fullWidth>
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          {isEditMfrMapping ? "Edit Manufacturer" : "Add Manufacturer"}
        </DialogTitle>
        <DialogContent sx={{ minHeight: "15vh" }}>
          <Typography fontSize="15px">
            {isEditMfrMapping
              ? "Select a catalog manufacturer to Edit mapping."
              : "Select a DMS manufacturer and a catalog manufacturer to map them."}
          </Typography>
          <FormControl fullWidth sx={{ mt: 3 }}>
            <InputLabel id="manufacturerType">DMS Manufacturer Type</InputLabel>
            <Select
              value={mfrPopupFilter}
              fullWidth
              labelId="manufacturerType"
              size="small"
              id="manufacturerType"
              label="DMS Manufacturer Type"
              onChange={(e) => setMfrPopupFilter(e.target.value)}
            >
              <MenuItem selected value="all">
                All
              </MenuItem>
              <MenuItem value="part">Part</MenuItem>
              <MenuItem value="wholegood">Wholegood</MenuItem>
            </Select>
          </FormControl>
          <Box display={isEditMfrMapping ? "none" : "block"}>
            <FormControl variant="outlined" fullWidth sx={{ mt: 3 }}>
              <InputLabel id="manufacturer">DMS Manufacturer</InputLabel>
              <Select
                labelId="manufacturer"
                id="manufacturerId"
                size="small"
                label="DMS Manufacturer"
                fullWidth
                value={selectedDmsMfr?.manufacturerId ?? 0}
                onChange={(e) => handleChangeDMSManufacturer(e.target.value)}
              >
                {dmsManufacturersByEverest
                  .filter((n) => {
                    if (mfrPopupFilter === "all") return true;
                    if (
                      mfrPopupFilter === "wholegood" &&
                      n.isWholegoodManufacturer
                    )
                      return true;
                    if (mfrPopupFilter === "part" && n.isPartManufacturer)
                      return true;
                    return false;
                  })
                  .filter(
                    (x) =>
                      !dmsManufacturersBySetup.some(
                        (y) => y.manufacturerId === x.manufacturerId
                      ) && x.isActive
                  )
                  .map((col) => (
                    <MenuItem
                      key={col.manufacturerId}
                      value={col.manufacturerId}
                    >
                      <ListItemText
                        primary={
                          col.code +
                          " - " +
                          col.name +
                          " (" +
                          col.commonMfgId +
                          ")"
                        }
                      />
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          <FormControl variant="outlined" fullWidth sx={{ mt: 3 }}>
            <InputLabel id="catalog-mfr">Catalog Manufacturer</InputLabel>
            <Select
              labelId="catalog-mfr"
              id="catalogMfr"
              size="small"
              label="Catalog Manufacturer"
              fullWidth
              value={selectedCatalogMfr?.id ?? "0"}
              onChange={(e) => handleChangeCatalogMfr(e.target.value)}
            >
              {manufacturersByCatalog.map((col) => (
                <MenuItem key={col.id} value={col.id}>
                  <ListItemText
                    primary={
                      col?.shortTitle +
                      " - " +
                      col?.title +
                      (col?.commonMfgId ? " (" + col?.commonMfgId + ")" : "")
                    }
                  />
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography mt={3} color="error">
            {errorMessage}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={
              !selectedCatalogMfr ||
              !selectedDmsMfr ||
              addDmsManufacturerMutationResult.isLoading
            }
            endIcon={
              addDmsManufacturerMutationResult.isLoading ? (
                <CircularProgress color="inherit" size={20} />
              ) : (
                <></>
              )
            }
            onClick={() => {
              if (selectedDmsMfr && selectedCatalogMfr) handleAddManufacturer();
            }}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={deleteConfirm}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
          Confirm to Remove
        </DialogTitle>
        <DialogContent>
          WARNING! Performing this action will delete all data from Shopify. You
          will lose all of your data and this CANNOT be undone!
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            autoFocus
            onClick={() => {
              setDeleteConfirm(false);
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleOpenFinalConfirm}>
            Are you sure?
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={deleteFinalConfirm} fullWidth onClose={handleClose}>
        <DialogTitle style={{ cursor: "move" }}>Confirm to Remove</DialogTitle>
        <DialogContent>Are you sure to perform this action?</DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            autoFocus
            onClick={() => {
              setDeleteFinalConfirm(false);
            }}
          >
            No
          </Button>
          <Button variant="contained" onClick={onDeleteSetup}>
            YES
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
